import { PaymentNetwork } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

export const PAYMENT_NETWOKS_KONBINI: Array<string> = [
  PaymentNetwork.FAMILYMART,
  PaymentNetwork.LAWSON,
  PaymentNetwork.MINISTOP,
  PaymentNetwork.SEICOMART,
]

export const PAYMENT_NETWORKS_QR_CODE: Array<string> = [PaymentNetwork.PAYPAY]
